module.exports = __webpack_public_path__ + "af32f7d725c7aedeb723183fcdc368c2.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-94.svg
// module id = 606
// module chunks = 0